// UserData.js
import { writable } from 'svelte/store';

export let Dilemma = writable('');
export let pathNames = writable({});
export let pathValues = writable({});
// Store full criterion objects with name, category, polarity, and icon properties
export let Criteria = writable([]);
export let CriteriaCategorization = writable([]);
export let CriteriaPolarity = writable([]);


// Testing
// export let Criteria = writable(["Something"]);

// Example pathNames: {Path 0: 'Name 1', Path 1: 'Name 2'}
// Example pathValues: {Path 0: [28, 36], Path 1: [67, 50]}
// Example Criteria: ['Criteria 1', 'Cost (Time/Money...)']
